import { statusKeys } from '@functions/status'

export type StatusKey = typeof statusKeys[number]

export type StatusModel = {
  cache_key: number,
  id: number,
  key: StatusKey,
  options?: any,
  title: string,
}

const state = {
  id: null,
  options: {},
  title: '',
}

export const requiredFields = [
  { key: 'title' },
]

export default state
